import { useEffect, useRef, useState } from 'react'
import { config } from '../../appConfig'
import { WaterNeuron } from '../../clients/WaterNeuron'
import { ICP_ICP_ID, NICP_ICP_ID } from '../../constants/tokenIds'
import useConfig from '../../hooks/useConfig'
import { ICToken } from '../../interfaces/common'
import { WaterNeuronInfo } from '../../interfaces/staking'
import { logger } from '../../logger'
import useWallet from '../useWallet'

export const useWaterNeuron = () => {
  const { tokens } = useConfig()
  const { wallet } = useWallet()

  const [hasWnError, setHasWnError] = useState(false)
  const [wnInfo, setWnInfo] = useState<WaterNeuronInfo>({
    exchange_rate: 0n,
    total_icp_deposited: 0n,
    minimum_deposit_amount: 0n,
    minimum_withdraw_amount: 0n,
  })

  const waterNeuron = useRef<WaterNeuron>(undefined)

  const icpToken = tokens.find((t): t is ICToken => t.id === ICP_ICP_ID)
  const nicpToken = tokens.find((t): t is ICToken => t.id === NICP_ICP_ID)

  useEffect(() => {
    const fetchWnInfo = async () => {
      waterNeuron.current = new WaterNeuron(config.getAgent({ principalId: wallet.principalId }))

      try {
        const info = await waterNeuron.current.getInfo()

        setWnInfo(info)
      } catch (e) {
        setHasWnError(true)

        logger.error('Failed to fetch Water Neuron info', { originalError: e })
      }
    }

    fetchWnInfo()
  }, [])

  return {
    hasWnError,
    wnInfo,
    waterNeuron,
    icpToken,
    nicpToken,
  }
}
